import { useCheckOtpQuery } from 'hooks/react-query/otp/use-check-otp.query';
import { useFetch } from 'hooks/use-fetch/use-fetch';
import { otpRequestConfig } from 'request-config/otp/otp.request-config';
import useQueryLocation from 'hooks/use-query';

export const useOtpAccess = () => {
  const { otpId, createDamageOtpCode } = useCheckOtpQuery();
  const queryLocation = useQueryLocation();

  const { fetch: deactivateOtpFetch } = useFetch({
    loadingKey: `deactivateOtp${createDamageOtpCode}`,
    isExcludeToken: true,
    ...otpRequestConfig.deactivateOtp(createDamageOtpCode as string)
  });

  const deactivateOtpHandler = () => {
    if (otpId) {
      deactivateOtpFetch();
    }
  };

  return { isOtpPage: !!queryLocation.otp, otpId, deactivateOtpHandler };
};
